import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Contrato } from 'src/app/utils/dtos/ComunicacaoDTO';
import { ApiPaginate, ApiPaginateResult } from '../apiservices/apipaginated';
import { APIService } from '../apiservices/apiservices';
import { DevUtils } from '../apiservices/Utils';


type IApiResponse = {
  Item: any;
  erro: string;
}

interface IPaginateComunicacaoParams {
  [key: string]: any;
  operacao?: string;
  contrato?: string;
  empresa: string;
}

export interface ComunicacaoContrato {
  idComunicacao?: any;
  numContrato: string | number;
  idEmpresa: string | number;
  StatusRespostaPromocao?: any;
  contrato: Contrato;
  DataLimiteRespostaPromocao: string | number;
  FlgRespostaAceitaPromocao?: any;
  LoginUsuarioRespondeuPromocao?: any;
  NomeUsuarioRespondeuPromocao?: any;
  DataRespostaPromocao?: any;
  GravarLeituraLojista: boolean;
}

export interface ComunicacaoTexto {
  IdTexto?: any;
  IdTipoTexto: number;
  Texto: string;
  DataEnvioNotificacao: string;
  IdStatusComunicacaoTexto: number;
  [x: string]: any;
}

export interface IComunicado {
  idTipoComunicacao: number | string;
  idOrigem: number | string;
  titulo: string | number;
  comunicadoTipo: string | number;
  flgAlertaPorEmail: boolean;
  nomeAprovador: string | number;
  loginAprovador: string | number;
  dataComunicacao: string;
  nomeUsuarioCriacao: string | number;
  loginUsuarioCriacao: string | number;
  flgAprovado: boolean;
  ComunicacaoContratos: ComunicacaoContrato[];
  ComunicacaoTextos: ComunicacaoTexto[];
}

interface ComunicadosViewResponseDTO {
  data: Array<ComunicadoDTO.RootObject>;
  linhas: number;
  erro: string;
  status_ret: string;
}

@Injectable()
export class ComunicacaoProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }

  getPaginated(paginacao: ApiPaginate, params = {}) : Promise<ApiPaginateResult> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'comunicacao?operacao=pageView&' + paginacao.geraAPIUrl();

      me.http.get(url, {headers: this.header, params}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  getPaginatedComunicacaoContrato(paginacao: ApiPaginate, params = {}) : Promise<ApiPaginateResult> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'comunicacao?operacao=pageViewComunicacaoContrato&' + paginacao.geraAPIUrl();

      me.http.get(url, {headers: this.header, params}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }


  encerrarComunicacao(idComunicacao: number | string, idAtividadeBPM: string, dataLimiteCriacaoExcedida): Promise<any>
  {
    var me=this;

    return new Promise((resolve, reject) => {
      let url = new URL(APIService.API_URL + 'tarefas')
      url.searchParams.append('idComunicacao', idComunicacao.toString().trim())
      url.searchParams.append('idAtividadeBPM', idAtividadeBPM)
      url.searchParams.append('dataLimiteCriacaoExcedida', dataLimiteCriacaoExcedida)
      url.searchParams.append('operacao', 'encerrarComunicacao')

      ////console.log(requestData);
      me.http.post(url.toString(), {}, {
        headers: APIService.header
      }).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  getReplyTextComunicacao({
    idComunicacao,
    numContrato,
    idEmpresa
  }): Promise<any>
  {
    var me=this;

    return new Promise((resolve, reject) => {
      let url = new URL(APIService.API_URL + 'comunicacao')
      url.searchParams.append('idComunicacao', idComunicacao.toString())
      url.searchParams.append('idEmpresa', idEmpresa)
      url.searchParams.append('numContrato', numContrato)
      url.searchParams.append('operacao', 'resposta')

      ////console.log(requestData);
      me.http.get(url.toString(), {
        headers: APIService.header
      }).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }
  responderComunicacao({idComunicacao, queroParticipar = null, idEmpresa, numContrato, idAtividade}, {comunicacaoTexto, arquivos}): Promise<any>
  {
    var me=this;

    return new Promise((resolve, reject) => {
      let url = new URL(APIService.API_URL + 'comunicacao')
      url.searchParams.append('operacao', 'resposta')
      url.searchParams.append('idComunicacao', idComunicacao.toString())
      url.searchParams.append('queroParticipar', String(queroParticipar))
      url.searchParams.append('idEmpresa', idEmpresa)
      url.searchParams.append('numContrato', numContrato)
      url.searchParams.append('idAtividade', idAtividade)

      ////console.log(requestData);
      me.http.post(url.toString(), {comunicacaoTexto, arquivos}, {
        headers: APIService.header
      }).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  getComunicadoById(id: number | string, isTarefa = false): Promise<{Item: ComunicadoDTO.IdComunicacaoNavigation, erro: string}>
  {
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'comunicacao?operacao=comunicado&idComunicacao=' + id;
      let pr = {}

      isTarefa && (pr['isTarefa'] = 1)

      //isConsulta && (pr['consulta'] = 1)

      this.http.get(url, {headers: this.header, params: pr}).subscribe((result: any) => {
        if(result.status_ret != "NOK")
        {
          resolve({
            Item: result,
            erro: ""
          })
        }
        else {
          resolve({
            Item: null,
            erro: result.erro
          })
        }
      },
      (error) => {
        reject(error);
      });
    });
  }

  getFilesByIds(ids: string[] | number[]): Promise<any>
  {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'comunicacao?operacao=arquivos&ids=' + ids.join(',');

      me.http.get(url, {headers: this.header}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  getLidos(idComunicacao: number | string): Promise<any>
  {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'comunicacao?operacao=lido&idComunicacao=' + idComunicacao;

      me.http.get(url, {headers: this.header}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  postLeituraComunicacaoContrato(idComunicado, idEmpresa, contrato): Promise<any>
  {
    var me=this;

    return new Promise((resolve, reject) => {
      let url = new URL(APIService.API_URL + 'comunicacao')
      url.searchParams.append('operacao', 'lido')
      url.searchParams.append('idComunicacao', idComunicado)
      url.searchParams.append('empresa', idEmpresa)
      url.searchParams.append('contrato', contrato)

      ////console.log(requestData);
      me.http.post(url.toString(), {}, {
        headers: APIService.header
      }).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  deleteFiles(id:any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'comunicacao?ids=' + id + '&operacao=arquivos';
      
      me.http.delete(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na exclusão do contrato.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  delete(id:any): Promise<any> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'comunicacao?id=' + id;
      
      me.http.delete(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na exclusão do contrato.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  /**
   * Atualiza usuário
   * @param dadosJson json com os dados do comunicado
   * @returns 
   */
  add(dadosJson: any, params = {}): Promise<IApiResponse> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      var requestData=JSON.stringify(dadosJson);
      let url = APIService.API_URL + 'comunicacao';

      me.http.post(url,requestData,{headers:me.header, params})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              //console.log(jsonData.erro);
              var errodatavazio={
                'Item':null,
                'erro':'Erro na atualização do usuário.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }
}
